import CPServices from "@/services/census-preferences.js";

const state = {
    isLoadingPref: true,
    prefs: {},
    sortingCategory: "time",
    sortingSortBy: "asc",
    filter: []
};

const getters = {
    prefs(state) {
        return state.prefs;
    }
};

const actions = {
    /**
     * fetch user preferences from backend
     * then keep them in global store
     */
    async initGetCensusPrefs(store) {
        store.commit("setLoading", true);
        let prefs = await CPServices.getCensusPreferences();

        if (prefs.census_sorting_category) {
            state.sortingCategory = prefs.census_sorting_category;
        }
        
        if (prefs.census_sorting_sort_by) {
            state.sortingSortBy = prefs.census_sorting_sort_by
        }
        
        if (prefs.census_filter) {
            state.filter = prefs.census_filter
        }

        store.commit("setLoading", false);
    },
    /**
     * update dynamodb
     */
    async updateCensusPref({state}) {
        try {
            const payload = { 
                census_sorting_category: state.sortingCategory,
                census_sorting_sort_by: state.sortingSortBy,
                census_filter: state.filter
            }
            const response = await CPServices.updateCensusPreferences(payload);
            return response;
        } catch (error) {
            console.error("API Error:", error);
            return null;
        }
    }
};

const mutations = {
    setLoading(state, value) {
        state.isLoadingPref = value;
    },
    setCensusFilter(state, filter) {
        state.filter = filter;
    },
    setCensusSortingCategory(state, sortingCategory) {
        state.sortingCategory = sortingCategory;
    },
    setCensusSortingSortBy(state, sortingSortBy) {
        state.sortingSortBy = sortingSortBy;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};